module.exports = __webpack_public_path__ + "img/Result_MidHigh_0608_01.8b36da36.png";